var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('router-view',{attrs:{"language":_vm.language,"t":_vm.t,"handleLang":_vm.handleLang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }